<ion-footer>
  <div class="crossIcon" (click)="action('close')">
    <ion-icon name="close-outline"></ion-icon>
  </div>
  <div class="content">
    <ion-grid class="ion-padding-bottom">
      <ion-row class="ion-margin-bottom">
        <ion-col size="12">
          <div class="ion-text-center">
            <h3>{{'menu'|language:'Menu '}}</h3>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col *ngIf="commonService.userData" size="4" (click)="action('fav')" class="ion-padding-horizontal">
          <div class="ion-text-center">
            <img src="/assets/images/heartFav.svg" alt="">
            <p>{{vendDetails.isFavourite ? ('Removefrom' | language:'Remove from') : ('Addto' | language:'Add to') }}
              {{'favourities'|language:'Favourites'}}</p>
          </div>
        </ion-col>
        <ion-col [size]="commonService.userData ? 4 : 6" (click)="share('share')" class="ion-padding-horizontal">
          <div class="shareBtn">
            <button [disabled]="addDisable" class="shareBtnDisable">
              <img src="/assets/images/share.svg" alt="">
              <p>{{'share'|language:'Share'}}</p>
            </button>
          </div>
        </ion-col>
        <ion-col (click)="commonService.featureNotAvailable()" class="ion-padding-horizontal">
          <div class="ion-text-center">
            <img src="/assets/images/shopinfo.svg" alt="">
            <p>{{'shopInfo'|language:'Shop Info'}}</p>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-footer>